module.exports = __webpack_public_path__ + "img/39.3d0e8eea.png";